import { createSlice } from '@reduxjs/toolkit';

// project import
import defaultConfig from 'config';

// ==============================|| SLICE - CUSTOMIZATION ||============================== //

const initialState = {
    navType: defaultConfig.navType // 'light' | 'dark'
};

const customization = createSlice({
    name: 'customization',
    initialState,
    reducers: {
        setNavType(state, action) {
            state.navType = action.payload;
        },
        toggleNavType(state) {
            state.navType = state.navType === 'dark' ? 'light' : 'dark';
        }
    }
});

export default customization.reducer;

export const { setNavType, toggleNavType } = customization.actions;
